import {Injectable} from "@angular/core";
import {Platform} from "ionic-angular";
import {AngularFireDatabase} from "@angular/fire/database";
import {AngularFireAuth} from "@angular/fire/auth";
// import { Firebase } from "@ionic-native/firebase";
// import firebase from "firebase/app";
// import "firebase/storage";
// import { Storage } from "@ionic/storage";
import {App, ToastController} from "ionic-angular";

// import { Camera, CameraOptions } from "@ionic-native/camera";

@Injectable()
export class FirebaseProvider {
  badgeNumber: any;
  countchat: number = 0;
  countstatus = 0;
  captureDataUrl: string;

  constructor(
    public afd: AngularFireDatabase,
    public afAuth: AngularFireAuth,
    public platform: Platform,
    public app: App,
    public toastCtrl: ToastController,
    // public storage: Storage,
    // public firebasePlugin: Firebase,
    // public camera: Camera
  ) {
  }

  getCurrentUser() {
    return this.afAuth.auth.currentUser;
  }

  getItemsQuery(model, orderByChild, equalTo, limitToLast?) {
    if (limitToLast !== undefined) {
      return this.afd.list(model, ref =>
        ref
          .orderByChild(orderByChild)
          .equalTo(equalTo)
          .limitToLast(limitToLast)
      );
    } else {
      return this.afd.list(model, ref =>
        ref.orderByChild(orderByChild).equalTo(equalTo)
      );
    }
  }

  getItems(model) {
    return this.afd.list(model);
  }

  addItem(model, name) {
    return this.afd.list(model).push(name);
  }

  setItem(model, name) {
    return this.afd.object(model).set(name);
  }

  deleteItem(model, id) {
    return this.afd.object(model + '/' + id).remove();
  }

  getObject(model) {
    return this.afd.object(model);
  }

  updateItem(model, id, name): Promise<any> {
    return this.afd.list(model).update(id, name);
  }

  removeItem(model, id) {
    return this.afd.list(model).remove(id);
  }

  // loginGoogle() {
  //   this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  // }
  // loginFacebook() {
  //   this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
  // }
  logout() {
    this.afAuth.auth.signOut();
  }

  loginUser(newEmail: string, newPassword: string): Promise<any> {
    return this.afAuth.auth.signInWithEmailAndPassword(newEmail, newPassword);
  }

  resetPassword(email: string): Promise<void> {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

  logoutUser(): Promise<void> {
    return this.afAuth.auth.signOut();
  }

  signupUser(newEmail: string, newPassword: string): Promise<any> {
    return this.afAuth.auth.createUserWithEmailAndPassword(
      newEmail,
      newPassword
    );
  }

  // /* INICIO SUBIR A STORAGE*/
  // async uploadFilesStorage(uid, filename, file) {
  //   let storageRef = firebase.storage().ref();
  //   let path = `/fotoPerfil/${uid}/${filename}`;
  //   var iRef = storageRef.child(path);
  //   return await iRef
  //     .put(file)
  //     .then(res => {
  //       return iRef
  //         .getDownloadURL()
  //         .then(url => {
  //           console.log("res", url);
  //           return url;
  //         })
  //         .catch(error => {
  //           console.log("Error no url", error);
  //         });
  //     })
  //     .catch(error => {
  //       console.log("Error uploadFilesStorage", error);
  //     });
  // }

  // uploadPhotography(_uid, _filename, _image) {
  //   let storageRef = firebase.storage().ref();
  //   const imageRef = storageRef.child(`/fotoPerfil/${_uid}/${_filename}`);
  //   return imageRef
  //     .putString(_image, firebase.storage.StringFormat.DATA_URL)
  //     .then(res => {
  //       return res.downloadURL;
  //     });
  // }

  // deleteFilesStorage(file, uid): Promise<any> {
  //   let storageRef = firebase.storage().ref();
  //   let path = "/fotoPerfil/" + uid + "/" + file;
  //   var desertRef = storageRef.child(path);
  //   return desertRef
  //     .delete()
  //     .then(function() {})
  //     .catch(function(error) {
  //       console.log("Error", error);
  //     });
  // }
  // /* FIN SUBIR A STORAGE*/

  // /* INICIO TOMAR FOTOS Y SUBIR A STORAGE */

  // capturePhotoFromGallery() {
  //   const cameraOptions: CameraOptions = {
  //     quality: 50,
  //     sourceType: this.camera.PictureSourceType.PHOTOLIBRARY, //Set the source of the picture. Defined in Camera.PictureSourceType. Default is CAMERA. PHOTOLIBRARY : 0, CAMERA : 1, SAVEDPHOTOALBUM : 2
  //     destinationType: this.camera.DestinationType.DATA_URL,
  //     encodingType: this.camera.EncodingType.JPEG,
  //     mediaType: this.camera.MediaType.PICTURE
  //   };

  //   return this.camera.getPicture(cameraOptions).then(
  //     imageData => {
  //       this.captureDataUrl = "data:image/jpeg;base64," + imageData;
  //       return this.captureDataUrl;
  //     },
  //     err => {
  //       console.log("capturePhoto Error", err);
  //     }
  //   );
  // }

  // capturePhoto() {
  //   const cameraOptions: CameraOptions = {
  //     quality: 100,
  //     sourceType: this.camera.PictureSourceType.CAMERA,
  //     destinationType: this.camera.DestinationType.DATA_URL,
  //     encodingType: this.camera.EncodingType.JPEG,
  //     mediaType: this.camera.MediaType.PICTURE
  //   };

  //   return this.camera.getPicture(cameraOptions).then(
  //     imageData => {
  //       this.captureDataUrl = "data:image/jpeg;base64," + imageData;
  //       return this.captureDataUrl;
  //     },
  //     err => {
  //       console.log("capturePhoto Error", err);
  //     }
  //   );
  // }

  // async uploadPhotoInv(
  //   _referencia,
  //   _idServicio,
  //   _idUsuario,
  //   _filename,
  //   _image
  // ) {
  //   let data;
  //   let storageRef = firebase.storage().ref();
  //   const imageRef = storageRef.child(
  //     `${_referencia}/${_idServicio}/${_idUsuario}/${_filename}.jpg`
  //   );
  //   return await imageRef
  //     .putString(_image, firebase.storage.StringFormat.DATA_URL)
  //     .then(snapshot => {
  //       return imageRef
  //         .getDownloadURL()
  //         .then(url => {
  //           data = {
  //             snapshot: snapshot,
  //             url: url
  //           };
  //           return data;
  //         })
  //         .catch(error => {
  //           console.log("Error no url", error);
  //         });
  //     });
  // }

  // uploadPhotoProfile(_referencia, _idUsuario, _filename, _image) {
  //   let storageRef = firebase.storage().ref();
  //   const imageRef = storageRef.child(
  //     `${_referencia}/${_idUsuario}/${_filename}`
  //   );
  //   return imageRef
  //     .putString(_image, firebase.storage.StringFormat.DATA_URL)
  //     .then(res => {
  //       return imageRef
  //         .getDownloadURL()
  //         .then(url => {
  //           return url;
  //         })
  //         .catch(error => {
  //           console.log("Error no url", error);
  //         });
  //     });
  // }

  // /*FIN TOMAR FOTOS Y SUBIR A STORAGE */

  // /* INICIO NOTIFICATIONS PUSH */
  // notificationHandler(uid) {
  //   if (this.platform.is("ios")) {
  //     this.firebasePlugin.hasPermission().then(resp => {
  //       if (resp.isEnabled === false) {
  //         this.firebasePlugin.grantPermission().then(() => {
  //           console.log("We have permissions");
  //           this.activeFirebase(uid);
  //         });
  //       } else {
  //         console.log("We already have permissions");
  //         this.activeFirebase(uid);
  //       }
  //     });
  //   } else {
  //     this.activeFirebase(uid);
  //   }
  // }

  // showToast(msg) {
  //   let toast = this.toastCtrl.create({
  //     message: msg,
  //     duration: 10000,
  //     position: "top"
  //   });

  //   toast.present();
  // }

  // activeFirebase(uid) {
  //   console.log("activeFirebase", uid);
  //   this.firebasePlugin
  //     .getToken()
  //     .then(token => {
  //       console.log("this is my token", token);
  //     })
  //     .catch(error => {
  //       console.log("cannot update token, please check", error);
  //     });
  //   this.firebasePlugin.onNotificationOpen().subscribe(data => {
  //     if (data.tap == true) {
  //       if (typeof data.type !== "undefined") {
  //         let nav = this.app.getActiveNav();
  //         console.log("type", data.type);
  //         switch (data.type) {
  //           case "chat":
  //             nav.setRoot("ServiceStatusPage");
  //             break;

  //           case "status":
  //             nav.setRoot("ServiceStatusPage", { status: true });
  //             break;

  //           default:
  //             console.log("im a notification", data);
  //             break;
  //         }
  //       }
  //     } else if (data.tap == false) {
  //       console.log("data", data);
  //       console.log("type", data.type);
  //       switch (data.type) {
  //         case "chat":
  //           this.showToast("Nuevo mensaje en Chat: " + data.body);
  //           break;
  //         case "status":
  //           switch (data.body) {
  //             case "Fotografía de operador":
  //               this.showToast(data.body);
  //               break;
  //             default:
  //               this.showToast("Actulización  de estatus: " + data.body);
  //               break;
  //           }
  //           break;
  //         default:
  //           console.log("im a notification", data);
  //           break;
  //       }
  //     }
  //   });

  //   this.firebasePlugin.onTokenRefresh().subscribe((token: string) => {
  //     this.updateUser(uid, token);
  //   });

  //   this.firebasePlugin
  //     .getToken()
  //     .then((token: string) => {
  //       console.log("this is my token", token);
  //       this.updateUser(uid, token);
  //     })
  //     .catch(error => {
  //       console.log("cannot update token, please check", error);
  //     });
  // }

  // updateUser(uid, token) {
  //   let updateObject = {
  //     deviceToken: token
  //   };

  //   let userUsers = this.afd.object("/user/" + uid);
  //   userUsers.update(updateObject);
  // }

  // async unregister() {
  //   await this.firebasePlugin
  //     .unregister()
  //     .then(() => {
  //       console.log("stop receiving notifications");
  //     })
  //     .catch(error => {
  //       console.log("ERROR", error);
  //     });
  // }

  // /* FIN NOTIFICATIONS PUSH */

  getServiceDriver(serviceid: string, fb: string) {
    return this.afd.object(`/${fb}/${serviceid}/driver`).valueChanges();
  }

  getTrackingPointByDriverId(driverId: string) {
    return this.afd.object(`/drivers/${driverId}/lastLoc`).valueChanges();
  }
}



// WEBPACK FOOTER //
// ./src/providers/firebase/firebase.ts